// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setComplianceOwnerOption = createAction('[Compliance Report History Page] Set Owner Option', props());
